import React, { createContext, useContext, useState, useCallback } from 'react';
import type { BreadcrumbNavItem } from '@/components/PageBreadcrumb';

interface BreadcrumbContextType {
  items: BreadcrumbNavItem[];
  rightContent: React.ReactNode;
  setItems: (items: BreadcrumbNavItem[]) => void;
  setRightContent: (content: React.ReactNode) => void;
}

const BreadcrumbContext = createContext<BreadcrumbContextType | null>(null);

export const useBreadcrumb = () => {
  const ctx = useContext(BreadcrumbContext);
  if (!ctx) throw new Error('useBreadcrumb must be used within BreadcrumbProvider');
  return ctx;
};

export const BreadcrumbProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [items, setItemsState] = useState<BreadcrumbNavItem[]>([]);
  const [rightContent, setRightContentState] = useState<React.ReactNode>(null);

  const setItems = useCallback((newItems: BreadcrumbNavItem[]) => setItemsState(newItems), []);
  const setRightContent = useCallback((content: React.ReactNode) => setRightContentState(content), []);

  return (
    <BreadcrumbContext.Provider value={{ items, rightContent, setItems, setRightContent }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};
